import { Stream } from "@cloudflare/stream-react";
import { useRef, useState } from "react";
import {
  Animated,
  type LayoutChangeEvent,
  StyleSheet,
  View,
  type ViewStyle,
} from "react-native";

import { colors } from "@/constants/colors";

export function CloudflareStream({
  style,
  videoId,
}: {
  style?: ViewStyle;
  videoId: string;
}) {
  const [size, setSize] = useState<{ height: number; width: number } | null>(
    null,
  );
  const opacity = useRef(new Animated.Value(0)).current;

  const handleLayout = (e: LayoutChangeEvent) => {
    const { height, width } = e.nativeEvent.layout;
    setSize((prev) =>
      prev &&
      prev.height === Math.round(height) &&
      prev.width === Math.round(width)
        ? prev
        : { height: Math.round(height), width: Math.round(width) },
    );
  };

  const handleLoadedData = () => {
    Animated.timing(opacity, {
      duration: 2500,
      toValue: 1,
      useNativeDriver: false,
    }).start();
  };

  return (
    <View onLayout={handleLayout} style={[styles.container, style]}>
      {size && (
        <Animated.View style={[StyleSheet.absoluteFill, { opacity }]}>
          <Stream
            autoplay
            controls={false}
            height={`${size.height}px`}
            loop
            muted
            onPlaying={handleLoadedData}
            preload="auto"
            responsive={false}
            src={videoId}
            width={`${size.width}px`}
          />
        </Animated.View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    aspectRatio: 1206 / 2622,
    backgroundColor: "black",
    borderColor: "rgba(255, 255, 255, 1)",
    borderRadius: 30,
    borderWidth: 2,
    boxShadow: `0 0 10px 0px ${colors.white}`,
    height: "80vh" as unknown as number,
    overflow: "hidden",
  },
});
